import { CallAPI } from "@/util/GetAPIPermission";
import { APIVerifyResult } from "./api.type";

export type VerifyParams = {
    token: string;
}

export const CallAPI_GOOGLE_Verify = async (request: VerifyParams) => {
    const response = await CallAPI<APIVerifyResult>("/google/verify", "POST", request);
    return response.result;
};